'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _lodash = require('lodash');

var _EnterAddressFormStyle = require('./EnterAddressFormStyle.scss');

var _EnterAddressFormStyle2 = _interopRequireDefault(_EnterAddressFormStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressPlaceholder = (_dec = (0, _reactCssModules2.default)(_EnterAddressFormStyle2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AddressPlaceholder, _React$Component);

  function AddressPlaceholder() {
    (0, _classCallCheck3.default)(this, AddressPlaceholder);
    return (0, _possibleConstructorReturn3.default)(this, (AddressPlaceholder.__proto__ || (0, _getPrototypeOf2.default)(AddressPlaceholder)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressPlaceholder, [{
    key: 'fields',
    value: function fields() {
      var fields = (0, _lodash.compact)([this.props.address.companyName, (0, _lodash.compact)([this.props.address.firstName, this.props.address.lastName]).join(' '), this.props.address.addressLine1, this.props.address.addressLine2, this.props.address.city, this.props.address.stateName, this.props.address.zipcode, this.props.address.phone]);

      return fields;
    }
  }, {
    key: 'renderField',
    value: function renderField(value) {
      return _react2.default.createElement(
        'div',
        { key: (0, _lodash.uniqueId)() },
        value
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'a-addressPlaceholder', className: 't-text--secondary' },
        (0, _lodash.map)(this.fields(), this.renderField, this)
      );
    }
  }]);
  return AddressPlaceholder;
}(_react2.default.Component), _class2.propTypes = {
  address: _react.PropTypes.shape({
    companyName: _react.PropTypes.string,
    firstName: _react.PropTypes.string,
    lastName: _react.PropTypes.string,
    stateName: _react.PropTypes.string,
    zipcode: _react.PropTypes.string,
    phone: _react.PropTypes.string,
    addressLine1: _react.PropTypes.string,
    addressLine2: _react.PropTypes.string,
    city: _react.PropTypes.string
  })
}, _class2.defaultProps = {
  address: {
    companyName: '',
    firstName: '',
    lastName: '',
    stateName: '',
    zipcode: '',
    phone: '',
    addressLine1: '',
    addressLine2: '',
    city: ''
  }
}, _temp)) || _class);
exports.default = AddressPlaceholder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressForm/AddressPlaceholder.js
// module id = 2263
// module chunks = 0